import { createFileRoute, redirect } from '@tanstack/react-router'

/** Legacy `/enej/quizzes` (sem trailing slash). */
export const Route = createFileRoute('/_event/$eventSlug/quizzes')({
  beforeLoad: () => {
    throw redirect({
      to: '/quizzes',
      replace: true
    })
  }
})
